export default __webpack_public_path__ + "static/btn-talk-2980001f08a147517f18b9f4e5a34502.png";